import { useEffect, useState } from "react";
import { Zap, Clock } from "lucide-react";

// Cutoffs (local time)
// Before SAME_DAY_CUTOFF -> qualifies for same-day delivery
// SAME_DAY_CUTOFF..MIDNIGHT_CUTOFF -> qualifies for midnight surprise
// After MIDNIGHT_CUTOFF -> next-day morning
const SAME_DAY_CUTOFF = 15; // 3:00 PM
const MIDNIGHT_CUTOFF = 22; // 10:00 PM

function nextCutoff(now) {
  const h = now.getHours();
  const target = new Date(now);
  if (h < SAME_DAY_CUTOFF) {
    target.setHours(SAME_DAY_CUTOFF, 0, 0, 0);
    return { target, mode: "same-day" };
  }
  if (h < MIDNIGHT_CUTOFF) {
    target.setHours(MIDNIGHT_CUTOFF, 0, 0, 0);
    return { target, mode: "midnight" };
  }
  // After 10 PM -> next-day morning slot cutoff at 9 AM next day
  target.setDate(target.getDate() + 1);
  target.setHours(9, 0, 0, 0);
  return { target, mode: "next-morning" };
}

function format(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${m}m ${sec.toString().padStart(2, "0")}s`;
  return `${m}m ${sec.toString().padStart(2, "0")}s`;
}

export default function DeliveryCountdown({ compact = false }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const { target, mode } = nextCutoff(now);
  const remaining = target - now;

  const copy = {
    "same-day": { label: "for delivery today", icon: <Zap className="w-3.5 h-3.5" /> },
    "midnight": { label: "for a midnight surprise", icon: <Clock className="w-3.5 h-3.5" /> },
    "next-morning": { label: "for tomorrow morning delivery", icon: <Clock className="w-3.5 h-3.5" /> },
  }[mode];

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-widest bg-[#8C3A3A] text-white ${compact ? "" : "shadow-sm"}`}
      data-testid="delivery-countdown"
    >
      <span className="inline-flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
        {copy.icon}
      </span>
      <span>
        Order in <span data-testid="countdown-value" className="tabular-nums">{format(remaining)}</span> {copy.label}
      </span>
    </div>
  );
}
